<template>
  <section role="main" class="content-body">
    <header class="page-header">
      <h2>請假</h2>
      <div class="right-wrapper">
        <ol class="breadcrumbs">
          <li>
            <a href="/">
              <i class="fa fa-home"></i>
            </a>
          </li>
          <li><span>工作紀錄表</span></li>
          <li><span>請假</span></li>
        </ol>
      </div>
    </header>
    <!-- start: page -->
    <div id="tabs-0" class="row">
      <div id="tabs-03" class="row">
        <div class="col-md-12">
          <section class="panel">
            <div class="panel-body">
              <div class="form-group">
                <label class="col-md-2 control-label">學　　號<span style="color:#FF0000;">*</span>：</label>
                <div class="col-md-4">{{item.studentId}}</div>
                <label class="col-md-2 control-label">姓　　名<span style="color:#FF0000;">*</span>：</label>
                <div class="col-md-4">{{item.studentName}}</div>
              </div>
              <div class="form-group">
                <label class="col-md-2 control-label">班　　級<span style="color:#FF0000;">*</span>：</label>
                <div class="col-md-4">{{item.dradeClass}}</div>
                <label class="col-md-2 control-label">聘僱系所<span style="color:#FF0000;">*</span>：</label>
                <div class="col-md-4">{{item.deptName}}</div>
              </div>
              <div class="form-group">
                <label class="col-md-2 control-label">事　　由<span style="color:#FF0000;">*</span>：</label>
                <div class="col-md-9"><textarea style="width:100%" rows="8" v-model="form.content"></textarea></div>
              </div>
              <div class="form-group">
                <label class="col-md-2 control-label">日 期<span style="color:#FF0000;">*</span>：</label>
                <div class="col-md-9">{{item.workDate}}
                  <select v-model="form.startHour">
                    <option v-for="item in getNumbers(6, 22)" :key="item" :value="item">{{item | twoDigits}}</option>
                  </select> 時
                  <select v-model="form.startMin">
                    <option :value="0">00</option>
                    <option :value="30">30</option>
                  </select>分起　{{item.workDate}}
                  <select v-model="form.endHour">
                    <option v-for="item in getNumbers(6, 22)" :key="item" :value="item">{{item | twoDigits}}</option>
                  </select> 時
                  <select v-model="form.endMin">
                    <option :value="0">00</option>
                    <option :value="30">30</option>
                  </select>分止
                </div>
              </div>
              <br>
              <table width="100%">
                <tr>
                  <td align="right"><a href="#" @click.prevent="formClear" class="btn-upload btn" style="background-color:#666; border-color:#999; color:#FFF;">重　　填</a>　</td>
                  <td align="left"><a href="#" @click.prevent="formSubmit" class="btn-upload btn" style="background-color:#337AB7; border-color:#2E6DA4; color:#FFF;">送　　出</a></td>
                </tr>
              </table>
            </div>
          </section>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  data() {
    return {
      item: {},
      form: {
        content: "",
        startHour: 6,
        startMin: 0,
        endHour: 6,
        endMin: 0
      }
    };
  },
  computed: {
    id() {
      return this.$route.params.id;
    }
  },
  mounted() {
    this.load();
  },
  methods: {
    load() {
      this.$http.get("/api/workstudyStudent/leave/" + this.id).then(a => {
        this.item = a.body;
      });
    },
    formSubmit() {
      if (this.checkForm() == false) return;
      this.$http.post("/api/workstudyStudent/leave/" + this.id, this.form).then(a => {
        if (a.body.status) {
          alert("請假單資料已送出，等待審核。");
          this.$router.push("/student");
        } else {
          alert(a.body.msg);
          console.log(a.body.exstr);
        }
      });
    },
    formClear() {
      this.form.content = "";
      this.form.startHour = 6;
      this.form.startMin = 0;
      this.form.endHour = 6;
      this.form.endMin = 0;
    },
    checkForm() {
      if (this.form.content == "")  {
        alert("『請假事由』尚未填寫");
        return false;
      }
      if (
        this.form.startHour > this.form.endHour ||
        (this.form.startHour == this.form.endHour &&
          this.form.startMin > this.form.endMin)
      ) {
        alert("『開始時間』請晚於『結束時間』");
        return false;
      }
      if (
        this.form.startHour == this.form.endHour &&
        this.form.startMin == this.form.endMin
      ) {
        alert("『開始時間』不可與『結束時間』相同");
        return false;
      }
      return true;
    }
  }
};
</script>

<style>
</style>